import { render, staticRenderFns } from "./ProductsNeedtostock.vue?vue&type=template&id=7dc98b54&"
import script from "./ProductsNeedtostock.vue?vue&type=script&lang=js&"
export * from "./ProductsNeedtostock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports